import React from 'react';

import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { Form as FormShared } from '@bcp-channels-sharedcomponents-reactjs/form-utils/dist/components';
import {
	Box,
	Card,
	DividerLine,
	InputField,
	InputSelect,
	Spacer,
	Typography,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { IconTooltip } from '@components';
import { rem } from '@helpers';
import { Anything } from '@types';

import { FixedFooterPlaceholder } from '../../../fixedFooter/fixedFooter';
import { CorporateFormProps } from '../../corporateData.helper';
import { useCorporateFormHelper } from './corporateForm.helper';

// to fix not exists children prop in react-18
const Form = FormShared as any;

export const CorporateForm: React.FC<CorporateFormProps> = ({ title, pagePadding }) => {
	const {
		resources,
		form,
		phoneCodes,
		corporatePhoneFlagId,
		managerPhoneFlagId,
		popupMenuCorporateCountryRef,
		popupMenuManagerCountryRef,
		maxLengthCorporateContact,
		maxLengthManagerContact,
		handlePressCorporateIndicative,
		handlePressManagerIndicative,
		getInputProps,
		onClearOnlineShopName,
		onClearWebsite,
		onClearCorporateEmail,
		onClearCorporateContact,
		onClearManagerName,
		onClearManagerEmail,
		onClearManagerContact,
		submitForm,
		state,
	} = useCorporateFormHelper();

	return (
		<Box styles={{ flexDirection: 'column' }}>
			<Box styles={{ flexDirection: 'column', padding: pagePadding, whiteSpace: 'nowrap' }}>
				<Typography appearance="headline-200-02">{title}</Typography>
				<Spacer vertical={rem(40)} />

				{CoreHelper.isNullOrEmpty(state) && (
					<>
						<Box styles={{ alignItems: 'center' }}>
							<Typography appearance="subtitle-100-03">{resources.onlineShop}</Typography>
							<Spacer horizontal={rem(8)} />
							<IconTooltip tooltip={{ label: resources.tooltipOnlineShop }} />
						</Box>
						<Spacer vertical={rem(16)} />
					</>
				)}
				{/** Online Shop */}
				<Form name={form.name} ref={form.ref} style={{ flexDirection: 'column' }}>
					{CoreHelper.isNullOrEmpty(state) && (
						<>
							<Card.Base width={'100%'}>
								<Box styles={{ width: '100%' }}>
									<InputField
										mode="default"
										label={resources.inputOnlineShopName}
										inputProps={{
											maxLength: 40,
										}}
										onClearButtonPress={onClearOnlineShopName}
										{...(getInputProps('onlineShopName') as Anything)}
									/>
									<Spacer horizontal={rem(10)} />
									<InputField
										mode="default"
										label={resources.inputWebsite}
										onClearButtonPress={onClearWebsite}
										{...(getInputProps('website') as Anything)}
									/>
								</Box>
							</Card.Base>
							<Spacer vertical={rem(32)} />
						</>
					)}
					<Typography appearance="subtitle-100-03">{resources.contacts}</Typography>
					<Spacer vertical={rem(16)} />
					<Card.Base width={'100%'}>
						<Box styles={{ flexDirection: 'column', width: '100%' }}>
							{/** Corporate */}
							<Typography appearance="body-100-03">{resources.corporate}</Typography>
							<Spacer vertical={rem(16)} />
							<Box>
								<Box styles={{ width: '50%' }}>
									<InputField
										mode="default"
										label={resources.inputCorporateEmail}
										onClearButtonPress={onClearCorporateEmail}
										{...(getInputProps('corporateEmail') as Anything)}
									/>
								</Box>
								<Spacer horizontal={rem(10)} />
								<Box styles={{ width: '50%' }}>
									<Box styles={{ width: rem(150) }}>
										<InputSelect
											ref={popupMenuCorporateCountryRef}
											mode="default"
											inputField={{ label: resources.inputCountry }}
											startIcon={phoneCodes[corporatePhoneFlagId]?.leftIcon?.icon?.source}
											onPress={handlePressCorporateIndicative}
											popupMenu={{
												popupMenuHeight: { maxHeight: rem(150) },
												hideOnClick: true,
												items: phoneCodes,
												zIndex: 10,
											}}
										/>
									</Box>
									<Spacer horizontal={rem(8)} />
									<InputField
										mode="number"
										label={resources.inputCorporateContact}
										inputProps={{
											maxLength: maxLengthCorporateContact,
										}}
										onClearButtonPress={onClearCorporateContact}
										{...(getInputProps('corporateContact') as Anything)}
									/>
								</Box>
							</Box>
							<Spacer vertical={rem(24)} />
							<DividerLine />
							<Spacer vertical={rem(24)} />
							{/** Manager */}
							<Box styles={{ alignItems: 'center' }}>
								<Typography appearance="body-100-03">{resources.manager}</Typography>
								<Spacer horizontal={rem(8)} />
								<IconTooltip tooltip={{ label: resources.tooltipManager }} />
							</Box>
							<Spacer vertical={rem(16)} />
							<Box styles={{ width: '50%' }}>
								<InputField
									mode="default"
									label={resources.inputManagerName}
									onClearButtonPress={onClearManagerName}
									{...(getInputProps('managerName') as Anything)}
								/>
							</Box>
							<Spacer vertical={rem(16)} />
							<Box>
								<Box styles={{ width: '50%' }}>
									<InputField
										mode="default"
										label={resources.inputManagerEmail}
										onClearButtonPress={onClearManagerEmail}
										{...(getInputProps('managerEmail') as Anything)}
									/>
								</Box>
								<Spacer horizontal={rem(10)} />
								<Box styles={{ width: '50%' }}>
									<Box styles={{ width: rem(150) }}>
										<InputSelect
											ref={popupMenuManagerCountryRef}
											mode="default"
											inputField={{ label: resources.inputCountry }}
											startIcon={phoneCodes[managerPhoneFlagId]?.leftIcon?.icon?.source}
											onPress={handlePressManagerIndicative}
											popupMenu={{
												popupMenuHeight: { maxHeight: rem(150) },
												hideOnClick: true,
												items: phoneCodes,
												zIndex: 10,
											}}
										/>
									</Box>
									<Spacer horizontal={rem(8)} />
									<InputField
										mode="number"
										label={resources.inputManagerContact}
										inputProps={{
											maxLength: maxLengthManagerContact,
										}}
										onClearButtonPress={onClearManagerContact}
										{...(getInputProps('managerContact') as Anything)}
									/>
								</Box>
							</Box>
						</Box>
						<Spacer vertical={rem(32)} />
					</Card.Base>
				</Form>
			</Box>
			<FixedFooterPlaceholder onSubmitCorporateForm={submitForm} />
		</Box>
	);
};
